import React, { memo } from 'react'

const FilterSection = ({ label, children }) => {
    return (
        <div className={'filter-menu__item'}>
            <p className={'filter-menu__label'}>{label}</p>
            <div>{children}</div>
        </div>
    )
}

export default memo(FilterSection)
